import { Action } from '@ngrx/store';
import { PaginatorInterface } from '../../models/paginator.interface';

export enum EPaginatorActions {
  UpdatePaginator = '[PAGINATOR] Update paginator'
}

export class UpdatePaginator implements Action {
  public readonly type = EPaginatorActions.UpdatePaginator;
  constructor(public payload: PaginatorInterface) {}
}

export type PaginatorActions = UpdatePaginator;
